import React, { useState, useMemo } from "react";
import { Select, Form } from "antd";

const PeriodsComponent = ({
  periodVal,
  dateFields,
  dayFields,
  monthFields,
  weekFields,
  layout,
}) => {
  const [week, setweek] = useState(false);
  const [month, setmonth] = useState(false);
  const [day, setday] = useState(false);
  const [quarter, setquarter] = useState(false);
  useMemo(() => {
    setweek(false);
    setmonth(false);
    setday(false);
    setquarter(false);
    switch (periodVal) {
      case 0:
        setday(true);
        break;
      case 1:
        setweek(true);
        break;
      case 2:
        setmonth(true);
        break;
      case 3:
        setquarter(true);
        break;
    }
  }, [periodVal]);

  return (
    <div className="periods-container" style={{ flex: 1 }}>
      {day && (
        <Form.Item
          label="时间"
          name={dateFields}
          rules={[{ required: true, message: "请选择时间" }]}
          {...layout}
        >
          <Select placeholder="请选择时间">
            {[...new Array(24)].map((s, i) => (
              <Select.Option
                value={i < 10 ? `0${i}:00:00` : `${i}:00:00`}
                key={"i" + i}
              >
                {i < 10 ? `0${i}:00:00` : `${i}:00:00`}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      )}
      {month && (
        <Form.Item
          label="第几天"
          name={dayFields}
          rules={[{ required: true, message: "请选择第几天!" }]}
          {...layout}
        >
          <Select allowClear placeholder="请选择第几天!">
            {[...new Array(28)].map((item, index) => {
              return (
                <Select.Option key={"day" + index} value={index + 1}>
                  {index + 1}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      )}
      {quarter && (
        <>
          <Form.Item
            label="第几月"
            name={monthFields}
            rules={[{ required: true, message: "请选择第几月!" }]}
            {...layout}
          >
            <Select allowClear placeholder="请选择第几月">
              <Select.Option value={1}>1</Select.Option>
              <Select.Option value={2}>2</Select.Option>
              <Select.Option value={3}>3</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="第几天"
            name={dayFields}
            rules={[{ required: true, message: "请选择第几天!" }]}
            {...layout}
          >
            <Select allowClear placeholder="请选择第几天">
              {[...new Array(28)].map((item, index) => {
                return (
                  <Select.Option key={"day" + index} value={index + 1}>
                    {index + 1}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        </>
      )}
      {week && (
        <Form.Item
          label="巡检日"
          name={weekFields}
          rules={[{ required: true, message: "请选择巡检日!" }]}
          {...layout}
        >
          <Select placeholder="请选择巡检日">
            <Select.Option value={1}>星期一</Select.Option>
            <Select.Option value={2}>星期二</Select.Option>
            <Select.Option value={3}>星期三</Select.Option>
            <Select.Option value={4}>星期四</Select.Option>
            <Select.Option value={5}>星期五</Select.Option>
            <Select.Option value={6}>星期六</Select.Option>
            <Select.Option value={7}>星期天</Select.Option>
          </Select>
        </Form.Item>
      )}
    </div>
  );
};

export default React.memo(PeriodsComponent);
